import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { colors } from '../../styles';
import { Icon, IconName } from '../../atoms/icons';
import { smallScreenHeight } from './constants';
import NavLabel from './nav-label';
import NavBadge from './nav-badge';
import { strict } from 'assert';
import { lab } from 'd3';

export interface Props {
  className?: string;
  icon?: IconName;
  label?: string;
  baseColor?: string;
  badgeCount?: number;
  isActive?: boolean;
  onClick?: (e) => any;
  fleetIcon?: any;
  'data-title'?: string;
  'data-accesskey'?: string;
}

class NavItem extends React.Component<Props, any> {
  public render() {
    const {
      badgeCount,
      className,
      icon,
      isActive,
      baseColor,
      label,
      onClick,
      fleetIcon,
    } = this.props;

    return (
      <div
        data-title={this.props['data-title']}
        data-accesskey={this.props['data-accesskey']}
        className={`${className} nav-item ${isActive ? 'active' : ''}`}
        onClick={onClick}
      >
        {fleetIcon ? (
          fleetIcon
        ) : (
          <Icon
            className={'nav-item-icon'}
            icon={icon}
            baseColor={baseColor || colors.white}
            size={'lg'}
          />
        )}

        {!!badgeCount && <NavBadge badgeCount={badgeCount} />}
        {label && <NavLabel label={label} />}
      </div>
    );
  }
}

export default styled(NavItem)`
  width: 4rem;
  height: 4rem;
  min-height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  .nav-item-icon {
    opacity: 0.5;
  }
  &.active .nav-item-icon {
    opacity: 1 !important;
  }
  &:hover:not(.active) .nav-item-icon {
    opacity: 0.8;
  }
  &:hover .label {
    opacity: 1;
  }

  @media screen and (max-height: ${smallScreenHeight}) {
    height: 2.75rem;
    min-height: 2.75rem;
    .nav-item-icon {
      width: 1.25rem;
    }
  }
`;
